import React, { Component } from 'react';
import PreLoginPage from '../../../views/core/PreLoginPage';
// import PreloginLanding from '../../../views/common/PreloginLanding';

export default class Spotlightyr extends PreLoginPage{
    render(){
        return(
            <div id="content_sub" >
            <div>
                <h2>Jump To</h2>
            </div>
                <div id="ss-links" className="ss-links">
                    <a href="#a2019">2019</a>
                    <a href="#a2018">2018</a>
                    <a href="#a2017">2017</a>
                    <a href="#a2016">2016</a>
                    <a href="#a2015">2015</a>
                    <a href="#a2014">2014</a>
                    <a href="#a2013">2013</a>
                    <a href="#a2012">2012</a>
                    <a href="#a2011">2011</a>
                    <a href="#a2010">2010</a>
                    <a href="#a2009">2009</a>
                    <a href="#a2008">2008</a>
                    <a href="#a2007">2007</a>
                    <a href="#a2006">2006</a>
                    <a href="#a2005">2005</a>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/prelogin/src/components/Spotlightyr.js